import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MemberTableManager } from '@hero/web-components';
import { usePageContext } from '@hero/web-context';

export default function UsersPage() {
  const { t } = useTranslation(['dashboard']);
  const { setPageName } = usePageContext();

  useEffect(() => {
    setPageName(t('dashboard:Users.title'));
  }, [setPageName, t]);

  return (
    <div className="mt-6">
      <MemberTableManager displayForUser="carrier" redirect />
    </div>
  );
}
